<div class="animated fadeIn">
  <app-configurations-block [configurations]="globalConfigurations" [collapsible]="false" />
</div>
